import { document, window } from 'browser-monads';
import he from 'he';
import React, { useLayoutEffect } from "react";
//import srcImgShare from '../fonts/share.png'
//import srcFontPrefered from '../fonts/fontsize.png'
//import srcImgPrefered from '../fonts/off.png'
import { toast } from 'react-toastify';
import styled from 'styled-components';
import { ThemeUtils } from '../utils/ThemeUtils';
import EditPostButton from "./edit-post-button";
import FbLike from "./fblike";

const { localStorage } = window;

// var toastId;
// var time_to_alert = 5000;

var current_font_size = 100;

var share_url, share_text;
//Used at build time, primary category colors

const H2ModeWhite = styled.div`
height: 24px;
width: 75px;
border-radius: 11px;
color: #232322;
background-color: #FFFFFF;
font-family: "urw-din";
font-size: 8px;
font-weight: bold;
letter-spacing: 0;
line-height: 24px;
text-align: center;
border: 1px solid red;
margin-right:2px;
`

const H2ModeDark = styled.div`
height: 24px;
width: 75px;
color: #FFFFFF;
font-family: "urw-din";
font-size: 8px;
font-weight: bold;
letter-spacing: 0;
line-height: 24px;
text-align: center;
box-sizing: border-box;
border: 1px solid #979797;
border-radius: 11px;
background-color: #222222;
margin-left:2px;

`


const DivShareWeb = styled.div`
display: none;
text-align: center;
/*width: 300px;height: fit-content;background: white;*/
background: white;
position: fixed;
right: 15%;
top: 0;
margin-top: 80px;
background-color: #FFFFFF;
height: 58px;
width: fit-content;
border-radius: 29px;
/*-moz-box-shadow: 7px 7px 31px -12px rgba(0,0,0,0.8);
box-shadow: 7px 7px 31px -12px rgba(0,0,0,0.8);*/
box-shadow: 0 2px 14px 0 rgba(0,0,0,0.5);
padding-top: 6px;
padding-left: 10px;
padding-right: 10px;
`

const DivFontSize = styled.div`
display: none;
text-align: center;
background: white;

position: fixed;
top:0;
margin-top: 80px;
right: 25%;

height: 99px;
width: 193px;
border-radius: 29px;
/*-moz-box-shadow: 7px 7px 31px -12px rgba(0,0,0,0.8);
box-shadow: 7px 7px 31px -12px rgba(0,0,0,0.8);*/
background-color: #FFFFFF;
box-shadow: 0 2px 14px 0 rgba(0,0,0,0.5);
padding-top: 6px;
`

// var color_mode;
// if (localStorage.getItem("font_color_mode")===null) {
//   //Se non è impostato dall'utente imposto il dark mod in base
//   //al tema del computer/smartphone, solo su safari
//   if(window.matchMedia('(prefers-color-scheme: dark)').matches){
//     color_mode = "dark";
//   } else {
//     color_mode = "";
//   }
// } else {
//   color_mode = localStorage.getItem('font_color_mode')?localStorage.getItem('font_color_mode'):"";
// }

//var is_prefered = false
var is_end = false
var is_middle = false
var starting_class_icon_prefered = "icon_prefered";
// var done_single_share = "";
// var done_share = false;


function reset_pref_color(link) {

  var color_mode;
  //return;
  //alert("reset_pref_color: "+link);
  if (localStorage.getItem("font_color_mode")===null) {
    //Se non è impostato dall'utente imposto il dark mod in base
    //al tema del computer/smartphone, solo su safari
    if(window.matchMedia('(prefers-color-scheme: dark)').matches){
      color_mode = "dark";
    } else {
      color_mode = "";
    }
  } else {
    color_mode = localStorage.getItem('font_color_mode')?localStorage.getItem('font_color_mode'):"";
  }

  if (!link) link = window.location.pathname;
  //alert("reset_pref_color share ")

  is_end = localStorage.getItem(link+'_end')
  is_middle = localStorage.getItem(link+'_middle')

  //alert("reset_pref_color share "+is_prefered)

  //alert(is_prefered)

  if (is_prefered(link)) starting_class_icon_prefered = "icon_prefered icon_prefered_set"+(color_mode==="dark"?"":"")
  else if (is_end) starting_class_icon_prefered = "icon_prefered icon_prefered_read"+(color_mode==="dark"?"":"")
  else if (is_middle) starting_class_icon_prefered = "icon_prefered icon_prefered_middle"+(color_mode==="dark"?"":"")

  //console.log("modifico elemento "+'icon_prefered_'+link+' is_prefered:'+is_prefered(link));

  Array.prototype.forEach.call(window.document.getElementsByClassName('icon_prefered_'+link), function(element) {
    //alert("trovato");

    //console.log("modifico elemento "+element.class);

    if (color_mode==="dark") {element.classList.add("icon_prefered")}

    element.classList.remove("icon_prefered_read")
    element.classList.remove("icon_prefered_read_black")
    element.classList.remove("icon_prefered_middle")
    element.classList.remove("icon_prefered_middle_black")
    element.classList.remove("icon_prefered_set")
    element.classList.remove("icon_prefered_set_black")

    if (is_prefered(link)) element.classList.add("icon_prefered_set"+(color_mode === "dark"?"":""))
    //else if (is_end) element.classList.add("icon_prefered_read"+(color_mode == "dark"?"dark":""))
    //else if (is_middle) element.classList.add("icon_prefered_middle"+(color_mode == "dark"?"dark":""))

  });

}

function play_button(){
  document.getElementById("click").play()
  //audio.play();
}

function is_prefered(link) {
  return localStorage.getItem(link+'_prefered');
}

function toggle_preferred(link, title, img, author, video, is_media) {

  //alert("toggle: "+link+" "+title+" "+img+" "+author+" "+video+" "+is_media);
  play_button();
  var unread = parseInt(localStorage.getItem("unread")?localStorage.getItem("unread"):0)
  if (unread < 0 ) unread = 0

  if (is_prefered(link)) {
    if (unread>0)
    unread--

    unset_preferred(link)
  }
  else {
    unread++

    set_preferred(link, title, img, author, video, is_media)
  }

  localStorage.setItem("unread", unread)
  if (unread > 0) {
    document.getElementById("unread_menu").style.display = "block"
    document.getElementById("unread_menu").innerHTML = unread
  } else {
    document.getElementById("unread_menu").style.display = "none"
  }
}

function set_preferred(link, title, img, author, video, is_media) {
  mag_set_preferred(link, title, img, author, video, is_media);

  //is_prefered = true
  reset_pref_color(link)
}

function unset_preferred(link) {
  mag_remove_preferred(link);
  //is_prefered = false
  reset_pref_color(link)
}

function set_preferred_in_page() {
  //return;
  var elements = document.getElementsByClassName("icon_prefered");
  //console.log('found:'+elements.length);
  for ( var i = 0; i < elements.length; i++ ) {
    //console.log('classlist:'+elements[i].classList.length);
    for (var b = 0; b < elements[i].classList.length; b++) {
      var classname = elements[i].classList.item(b);
      //console.log('className:'+classname + ' checkfor:'+classname.replace("icon_prefered_",""));
      if (window.localStorage.getItem(classname.replace("icon_prefered_","")+"_prefered" )) {
        //console.log('found prefered:'+classname.replace("icon_prefered_",""));
        reset_pref_color(classname.replace("icon_prefered_",""), "noupdate");
      }
    }
  }
}

function toggle_wrapper (components_name_md5) {
  if (window.document.getElementById("div_fontsize"+components_name_md5) &&
  (window.document.getElementById("div_fontsize"+components_name_md5).style.display !== "none" || window.document.getElementById("div_shareeweb"+components_name_md5).style.display !== "none")) {
    window.document.getElementById("div_fontsize"+components_name_md5).style.display = "none";
    window.document.getElementById("div_shareeweb"+components_name_md5).style.display = "none";
    window.document.getElementById("div_fontsize_wrapper"+components_name_md5).style.display = "none";
  }
}
function readingUa() {
  return window.navigator.userAgent;
}

function toggle_font_size (components_name_md5, showonly_option) {
  window.document.getElementById("div_fontsize"+components_name_md5).style.display =  document.getElementById("font_share").getBoundingClientRect().right;
  if (!showonly_option && window.document.getElementById("div_fontsize"+components_name_md5).style.display === "block") {
    window.document.getElementById("div_fontsize"+components_name_md5).style.display = "none";
    if (!showonly_option) window.document.getElementById("div_fontsize_wrapper"+components_name_md5).style.display = "none";
  } else {
    window.document.getElementById("div_fontsize"+components_name_md5).style.display = "block";
    if (!showonly_option) window.document.getElementById("div_fontsize_wrapper"+components_name_md5).style.display = "block";
  }
}

function toggle_share (components_name_md5) {

  if (window.innerWidth<=500 && navigator.share !== undefined) {
    //native sharer
    share();
  } else {
    if (window.document.getElementById("div_shareeweb"+components_name_md5).style.display === "block") {
      window.document.getElementById("div_shareeweb"+components_name_md5).style.display = "none";
      window.document.getElementById("div_fontsize_wrapper"+components_name_md5).style.display = "none";
    } else {
      window.document.getElementById("div_shareeweb"+components_name_md5).style.display = "block";
      window.document.getElementById("div_fontsize_wrapper"+components_name_md5).style.display = "block";
    }
  }
}

function reduce_font_size(components_name_md5) {

  if (window.ga) {
    window.ga('send', {
      hitType: 'event',
      eventCategory: 'Option',
      eventAction: 'change font',
      eventLabel: 'reduce'
    });
  }

  if (parseInt(localStorage.getItem('font_size')) <= 40) return;
  //window.alert('reduce_font_size');
  current_font_size = parseInt(localStorage.getItem('font_size')) - 5;
  localStorage.setItem('font_size', current_font_size);
  document.getElementById('font_range').value = current_font_size;
  ThemeUtils.set_font_color(components_name_md5);
  //console.log('reduce_font_size');
}

function set_font_size(components_name_md5, size) {
  //window.alert('enlarge_font_size');
  //if (size > 180 || size < 40) return;
  if (window.ga) {
    window.ga('send', {
      hitType: 'event',
      eventCategory: 'Option',
      eventAction: 'change font',
      eventLabel: 'set'
    });
  }

  current_font_size = size;
  localStorage.setItem('font_size', current_font_size);
  ThemeUtils.set_font_color(components_name_md5);
  //console.log('enlarge_font_size');
}


function enlarge_font_size(components_name_md5) {
  //window.alert('enlarge_font_size');
  if (window.ga) {
    window.ga('send', {
      hitType: 'event',
      eventCategory: 'Option',
      eventAction: 'change font',
      eventLabel: 'enlarge'
    });
  }

  if (parseInt(localStorage.getItem('font_size')) >= 180) return;

  current_font_size = parseInt(localStorage.getItem('font_size')) + 5;

  localStorage.setItem('font_size', current_font_size);
  document.getElementById('font_range').value = current_font_size;
  ThemeUtils.set_font_color(components_name_md5);
  //console.log('enlarge_font_size');
}

var facebook_is_visible = true;
var linkedin_is_visible = true;
var normal_share_is_visible = true;
var articlesave_is_visible = true;

var ua = readingUa();
if (ua.match(/linkedin/i))  {
  facebook_is_visible = false;
  linkedin_is_visible = true;
  normal_share_is_visible = false;
  articlesave_is_visible = false;
} else if (ua.match(/FBAN/i) || ua.match(/FB_IAB/i)) {
  facebook_is_visible = true;
  linkedin_is_visible = false;
  normal_share_is_visible = false;
  articlesave_is_visible = false;
} else if (window.innerWidth<=500) {
  facebook_is_visible = false;
  linkedin_is_visible = false;
  normal_share_is_visible = true;
  articlesave_is_visible = true;
}

var decodeHTML = function (html) {
  var txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};

async function share() {
  if (navigator.share === undefined) {
    //window.alert('not ye');
  } else {
    //window.alert('share ok');
    var title, text;

    try {
      title =  decodeHTML(document.querySelectorAll('meta[property="og:title"]')[0].content);
    } catch (erro) {}

    try {
      text = decodeHTML(document.querySelectorAll('meta[property="og:title"]')[0].content) + "  \n"+window.location.href;
    } catch (erro) {
      if (title)
      text = title + " " +window.location.href;
      else
      text = window.location.href;
    }

    var url = window.location.href;
    var files = undefined;

    if (files && files.length > 0) {
      if (!navigator.canShare || !navigator.canShare({files})) {
        //window.alert('Error: Unsupported feature: navigator.canShare()');
        document.getElementsByClassName('share_web_icon')[0].classList.add('sharethis-inline-share-buttons')
        return;
      }
    }

    try {
      await navigator.share({files, title, text, url});
      //window.alert('Successfully sent share');
      if (localStorage.getItem("success_share")===null) {
        localStorage.setItem("success_share",1)
      } else {
        localStorage.setItem("success_share",parseInt(localStorage.getItem('font_size'))+1);
      }

      localStorage.setItem("share_"+window.location.href,Date.now() / 1000 | 0);
    } catch (error) {
      //window.alert('Error sharing: ' + error);
      localStorage.setItem("sharetentaive_"+window.location.href,Date.now() / 1000 | 0);
    }
  }
}


function mag_set_preferred(url, title, img, author, video, is_media) {
  //window.alert(JSON.stringify({url:url?url:window.location.pathname, title:title, img:img, author:author, video:video, is_media:is_media, time: Date.now()}));

  if (!url) url = window.location.pathname;

  localStorage.setItem(url+'_prefered', Date.now())

  localStorage.setItem(url+'_prefered_info', JSON.stringify({url:url, title:title, img:img, author:author, video:video, is_media:is_media, time: Date.now()}));

  // var toastId =
  toast("Aggiunto agli articoli salvati",{
    hideProgressBar: true,
    autoClose: 2000,
    closeOnClick: true
  }
  );
}

function mag_remove_preferred(url) {
  localStorage.removeItem(url?url+'_prefered':window.location.pathname+'_prefered');
  localStorage.removeItem(url?url+'_prefered_info':window.location.pathname+'_prefered_info');

  // var toastId =
  toast('Rimosso dagli articoli salvati',{
    hideProgressBar: true,
    autoClose: 2000,
    closeOnClick: true }
    );
  }

  function mag_show_toast(message, hide_progress, time) {
    // var toastId =
    toast(message,{
      hideProgressBar: hide_progress,
      autoClose: time,
      closeOnClick: true }
      );
    }

    if (typeof window !== 'undefined') {
      if (window.innerWidth>=500) {
        toast.configure({
          hideProgressBar: false,
          position: toast.POSITION.TOP_RIGHT,
          //draggable: false,
          //etc you get the idea
        });
      } else {
        toast.configure({
          hideProgressBar: false,
          position: toast.POSITION.BOTTOM_CENTER,
          //draggable: false,
          //etc you get the idea
        });
      }
    }

    function SharePanel ({ components_name_md5, float, margin, showonly_option, display, title, img, author, video, is_media, vertical, postId, kind }) {


      //var components_name_md5 =  Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      useLayoutEffect(()=>{
        //Mount client side
        console.log('SharePanel useLayoutEffect '+components_name_md5);

        // done_share = true;

        // if (components_name_md5)
        //   done_single_share = components_name_md5

        //alert(window.MAG);
        //if (window.MAG === undefined){
        console.log('SharePanel useLayoutEffect doing page layout theme');
        var MAG = class MAGAZINE{};
        //alert("init MAG");
        MAG.set_preferred = mag_set_preferred;
        MAG.remove_preferred = mag_remove_preferred;
        MAG.show_toast = mag_show_toast;
        MAG.toggle_preferred = toggle_preferred;
        MAG.is_prefered = is_prefered;
        MAG.reset_pref_color = reset_pref_color;
        MAG.set_font_color = (components_name_md5) => {ThemeUtils.set_font_color(components_name_md5)};


        window.MAG = MAG;
        window.toggle_preferred = function (link, title, img, author, video, is_media) {
          toggle_preferred(link, title, img, author, video, is_media);
          set_preferred_in_page();
        }

        var current_font_size = 100;
        if (localStorage.getItem('font_size')!==null) {
          current_font_size = parseInt(localStorage.getItem('font_size'));
        } else {
          localStorage.setItem('font_size', current_font_size);
        }

        if (document.getElementById('font_range'))
        document.getElementById('font_range').value = current_font_size;

        //localStorage.setItem('font_size', current_font_size);
        //console.log('fontsize '+current_font_size);

        //if (!done_share)

        console.log("set_font_color share useLayoutEffect");
        ThemeUtils.set_font_color(components_name_md5);




        //share();

        //var is_prefered = is_prefered(window.location.pathname)

        reset_pref_color(window.location.pathname);

        if (showonly_option) {
          toggle_font_size(components_name_md5, showonly_option );
        }
        //}

        window.addEventListener("keydown", function (e) {
          if (e.key === "Escape") {
            toggle_wrapper (components_name_md5);
          }
        })


        if (window.document.getElementById("newmag_social_share_facebook"+components_name_md5)  && !showonly_option)
        window.document.getElementById("newmag_social_share_facebook"+components_name_md5).style.display = facebook_is_visible?"flex":"none";

        if (window.document.getElementById("newmag_social_share_linkedin"+components_name_md5) && !showonly_option)
        window.document.getElementById("newmag_social_share_linkedin"+components_name_md5).style.display = linkedin_is_visible?"flex":"none";

        if (window.document.getElementById("newmag_social_share_web"+components_name_md5) && !showonly_option) {
          window.document.getElementById("newmag_social_share_web"+components_name_md5).style.display = normal_share_is_visible?"block":"none";
          //window.document.getElementById("div_shareeweb_fb"+components_name_md5).style.display = facebook_is_visible?"none":"block";
          //window.document.getElementById("div_shareeweb_ln"+components_name_md5).style.display = linkedin_is_visible?"none":"block";
        }

        if (window.document.getElementById("newmag_savearticle"+components_name_md5) && !showonly_option)
        window.document.getElementById("newmag_savearticle"+components_name_md5).style.display = articlesave_is_visible?"block":"none";

        //window.alert("newmag_social_share_web: "+normal_share_is_visible?"yes":"no");
        return () => {
          window.removeEventListener("keydown", function (e) {
            if (e.key === "Escape") {
              toggle_wrapper (components_name_md5);
            }
          })
        };
      });

      share_url = encodeURIComponent(window.location.href);

      var convertedValue;
      try {
        convertedValue = he.decode(title);
        share_text = convertedValue;
      }catch (error) {
        share_text = "";
      }

      var news_url = window.location.pathname;
      var news_title = title;
      var news_image = img;
      var news_video = video;
      var news_is_media = is_media;
      var news_author = author;

      // var shareurl="https://www.facebook.com/StartupItalia.eu";
      return (
        (!display || display !== "none") && (
          <div
            id={"newmag_social_share" + components_name_md5}
            className={
              "newmag_social_share" +
              components_name_md5 +
              " newmag_social_share"
            }
            style={{
              float: float ? float : "right",
              display: display ? display : "flex",
              paddingTop: "4px",
              textAlign: "right",
              alignContent: "right",
              background: "",
              margin: margin ? margin : "auto 0 auto auto",
              paddingRight: "15px",
            }}
          >
            {facebook_is_visible && (
              <div
                id={"newmag_social_share_facebook" + components_name_md5}
                className="newmag_social_share_facebook"
                style={{
                  display: "none",
                  float: "right",
                  marginTop: "6px",
                  marginRight: "-20px",
                }}
              >
                <FbLike />
              </div>
            )}

            {linkedin_is_visible && !showonly_option && (
              <div
                id={"newmag_social_share_linkedin" + components_name_md5}
                className="newmag_social_share_linkedin"
                style={{
                  display: "none",
                  float: "right",
                  marginTop: "5px",
                  marginRight: "20px",
                }}
                dangerouslySetInnerHTML={{
                  __html: `
        <div class="linkedin-root" id="linkedin-root" style="display: flex;padding-top: 6px;margin-left: 18px;">
        <script src="https://platform.linkedin.com/in.js" type="text/javascript">lang: en_US</script>
        <script type="IN/Share"></script>
        </div>
        `,
                }}
              />
            )}

            <div style={{marginRight: '1rem'}}>
              <EditPostButton postId={postId} vertical={vertical} kind={kind} />
            </div>

            {normal_share_is_visible && !showonly_option && (
              <div
                role="button"
                tabIndex="0"
                id={"newmag_social_share_web" + components_name_md5}
                className="newmag_social_share_web"
                style={{ cursor: "pointer", display: "none", float: "right" }}
                alt="Share article"
                onClick={() => toggle_share(components_name_md5)}
                onKeyDown={(event) => {
                  if (event.key === "Enter") toggle_share(components_name_md5)
                }}
              >
                <img
                  className="icon_share share_icons"
                  id="icon_share"
                  alt="Share article"
                  src="/img/share@2x.png"
                  style={{ marginTop: "7px", width: "27px", height: "auto" }}
                />
              </div>
            )}

            <div
              role="button"
              tabIndex="0"
              className="sharepanel_fontsize"
              style={{
                cursor: "pointer",
                marginLeft: "30px",
                display: showonly_option ? "none" : "block",
              }}
              onClick={() => toggle_font_size(components_name_md5)}
              onKeyDown={(event) => {
                if (event.key === "Enter") toggle_font_size(components_name_md5)
              }}
            >
              <img
                alt="Set font size"
                className="font_share share_icons"
                id="font_share"
                src={"/img/font_resize@2x.png"}
                style={{ marginTop: "0px", width: "40px", height: "auto" }}
              />
            </div>

            {articlesave_is_visible && !showonly_option && (
              <div
                role="button"
                tabIndex="0"
                id={"newmag_savearticle" + components_name_md5}
                className="newmag_savearticle"
                onClick={() =>
                  toggle_preferred(
                    window.news_url ? window.news_url : news_url,
                    window.news_title ? window.news_title : news_title,
                    window.news_image ? window.news_image : news_image,
                    window.news_author ? window.news_author : news_author,
                    window.news_video ? window.news_video : news_video,
                    window.news_is_media ? window.news_is_media : news_is_media
                  )
                }
                onKeyDown={(event) => {
                  if (event.key === "Enter")
                    toggle_preferred(
                      window.news_url ? window.news_url : news_url,
                      window.news_title ? window.news_title : news_title,
                      window.news_image ? window.news_image : news_image,
                      window.news_author ? window.news_author : news_author,
                      window.news_video ? window.news_video : news_video,
                      window.news_is_media
                        ? window.news_is_media
                        : news_is_media
                    )
                }}
                style={{
                  display: "none",
                  marginLeft: "30px",
                  marginRight: "10px",
                }}
              >
                <img
                  className={
                    starting_class_icon_prefered +
                    " share_icons icon_prefered icon_prefered_" +
                    window.location.pathname
                  }
                  id="prefered_share"
                  alt="Set prefered"
                  src={"/img/off@2x_fill.png"}
                  style={{ marginTop: "7px", width: "26px", height: "auto" }}
                />
              </div>
            )}

            {normal_share_is_visible && !showonly_option && (
              <DivShareWeb
                id={"div_shareeweb" + components_name_md5}
                className="div_shareeweb"
                style={{ zIndex: "2", display: "none" }}
              >
                <div style={{ display: "flex", height: "50px" }}>
                  <a
                    id={"div_shareeweb_fb" + components_name_md5}
                    className="resp-sharing-button__link"
                    href={
                      "https://facebook.com/sharer/sharer.php?u=" + share_url
                    }
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Facebook"
                  >
                    <div className="resp-sharing-button resp-sharing-button--facebook resp-sharing-button--medium">
                      <div
                        aria-hidden="true"
                        className="resp-sharing-button__icon resp-sharing-button__icon--solid"
                      >
                        <img alt="facebook" src={"/img/facebook@2x.png"} />
                      </div>
                    </div>
                  </a>

                  <a
                    className="resp-sharing-button__link"
                    href={
                      "https://twitter.com/intent/tweet/?text=" +
                      share_text +
                      "&amp;url=" +
                      share_url
                    }
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Twitter"
                  >
                    <div className="resp-sharing-button resp-sharing-button--twitter resp-sharing-button--medium">
                      <div
                        aria-hidden="true"
                        className="resp-sharing-button__icon resp-sharing-button__icon--solid"
                      >
                        <img alt="twitter" src={"/img/twitter@2x.png"} />
                      </div>
                    </div>
                  </a>

                  <a
                    className="resp-sharing-button__link"
                    href={
                      "mailto:?subject=" + share_text + "&amp;body=" + share_url
                    }
                    target="_self"
                    rel="noreferrer"
                    aria-label="E-Mail"
                  >
                    <div className="resp-sharing-button resp-sharing-button--email resp-sharing-button--medium">
                      <div
                        aria-hidden="true"
                        className="resp-sharing-button__icon resp-sharing-button__icon--solid"
                      >
                        <img alt="mail" src={"/img/mail@2x.png"} />
                      </div>
                    </div>
                  </a>

                  {/*<a className="resp-sharing-button__link" href={"https://pinterest.com/pin/create/button/?url="+share_url+"&amp;media="+share_url+"&amp;description="+share_text} target="_blank" rel="noopener" aria-label="Pinterest">
        <div className="resp-sharing-button resp-sharing-button--pinterest resp-sharing-button--medium"><div aria-hidden="true" className="resp-sharing-button__icon resp-sharing-button__icon--solid">
        <img src={"/img/pinterest@2x.png"}/></div></div>
      </a>*/}

                  <a
                    id={"div_shareeweb_ln" + components_name_md5}
                    className="resp-sharing-button__link"
                    href={
                      "https://www.linkedin.com/shareArticle?mini=true&amp;url=" +
                      share_url +
                      "&amp;title=" +
                      share_text +
                      "&amp;summary=" +
                      share_text +
                      "&amp;source=" +
                      share_url
                    }
                    target="_blank"
                    rel="noreferrer"
                    aria-label="LinkedIn"
                  >
                    <div className="resp-sharing-button resp-sharing-button--linkedin resp-sharing-button--medium">
                      <div
                        aria-hidden="true"
                        className="resp-sharing-button__icon resp-sharing-button__icon--solid"
                      >
                        <img alt="linkedin" src={"/img/linkedin@2x.png"} />
                      </div>
                    </div>
                  </a>

                  <a
                    className="resp-sharing-button__link"
                    href={
                      "whatsapp://send?text=" + share_text + "%20" + share_url
                    }
                    target="_blank"
                    rel="noreferrer"
                    aria-label="WhatsApp"
                  >
                    <div className="resp-sharing-button resp-sharing-button--whatsapp resp-sharing-button--medium">
                      <div
                        aria-hidden="true"
                        className="resp-sharing-button__icon resp-sharing-button__icon--solid"
                      >
                        <img alt="whatsapp" src={"/img/whatsapp@2x.png"} />
                      </div>
                    </div>
                  </a>

                  <a
                    className="resp-sharing-button__link"
                    href={
                      "https://telegram.me/share/url?text=" +
                      share_text +
                      "&url=" +
                      share_url
                    }
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Telegram"
                  >
                    <div className="resp-sharing-button resp-sharing-button--telegram resp-sharing-button--medium">
                      <div
                        aria-hidden="true"
                        className="resp-sharing-button__icon resp-sharing-button__icon--solid"
                      >
                        <img alt="telegram" src={"/img/telegram@2x.png"} />
                      </div>
                    </div>
                  </a>
                </div>
              </DivShareWeb>
            )}

            <DivFontSize
              id={"div_fontsize" + components_name_md5}
              className="div_fontsize"
              style={{
                display: "none",
                height: showonly_option ? "fit-content" : "",
                width: showonly_option ? "280px" : "",
                zIndex: "2",
                // display:"none",
                position: showonly_option ? "relative" : "",
                marginTop: showonly_option ? "20px" : "",
                marginBottom: showonly_option ? "20px" : "",
              }}
            >
              {showonly_option && (
                <div style={{ display: "flex", height: "50px" }}>
                  <div style={{ width: "100%", margin: "auto" }}>
                    <p
                      style={{
                        fontSize: "20px",
                        margin: "auto",
                        fontWeight: "500",
                      }}
                    >
                      Dimensione
                    </p>
                  </div>
                </div>
              )}

              <div style={{ width: "100%", margin: "auto", display: "flex" }}>
                <div style={{ width: "0%", margin: "auto" }} />
                <div
                  style={{ cursor: "pointer", width: "15%", margin: "auto" }}
                  onClick={() => reduce_font_size(components_name_md5)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === "Space") {
                      reduce_font_size(components_name_md5)
                    }
                  }}
                  role="button"
                  tabIndex="0"
                >
                  <h2
                    style={{
                      fontSize: "18px",
                      margin: "auto",
                      fontWeight: "500",
                    }}
                  >
                    - A
                  </h2>
                </div>
                <div style={{ cursor: "pointer", width: "50%" }}>
                  <div
                    style={{
                      display: "block",
                      marginTop: showonly_option ? "-44px" : "-16px",
                      marginBottom: "-28px",
                      width: "",
                      textAlign: "center",
                    }}
                  >
                    <p
                      id={"div_fontsize_text" + components_name_md5}
                      style={{ fontSize: showonly_option ? "20px" : "14px" }}
                    >
                      {localStorage.getItem("font_size") + "%"}
                    </p>
                  </div>
                  <input
                    step="5"
                    onChange={() => {
                      set_font_size(
                        components_name_md5,
                        document.getElementById("font_range").value
                      )
                    }}
                    id="font_range"
                    type="range"
                    name="fontsize"
                    min="40"
                    max="180"
                  />
                </div>
                <div
                  style={{ cursor: "pointer", width: "10%", margin: "auto" }}
                  onClick={() => enlarge_font_size(components_name_md5)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === "Space") {
                      enlarge_font_size(components_name_md5)
                    }
                  }}
                  tabIndex="0"
                  role="button"
                >
                  <h2
                    style={{
                      fontSize: "30px",
                      margin: "auto",
                      fontWeight: "700",
                    }}
                  >
                    A+
                  </h2>
                </div>
                <div style={{ width: "5%", margin: "auto" }} />
              </div>
              <div
                style={{
                  display: "inline-flex",
                  height: showonly_option ? "40px" : "54px",
                }}
              >
                <H2ModeWhite
                  style={{ cursor: "pointer" }}
                  className="white_mode"
                  onClick={() =>
                    ThemeUtils.dark_mode_toggle_exec(
                      components_name_md5,
                      "white"
                    )
                  }
                >
                  WHITE MODE
                </H2ModeWhite>
                <H2ModeDark
                  style={{ cursor: "pointer" }}
                  className="dark_mode"
                  onClick={() =>
                    ThemeUtils.dark_mode_toggle_exec(
                      components_name_md5,
                      "dark"
                    )
                  }
                >
                  DARK MODE{" "}
                </H2ModeDark>
              </div>

              {showonly_option && (
                <div>
                  <p style={{ fontSize: "16px", marginTop: "4px" }}>
                    <div style={{ width: "33%", margin: "auto" }}>
                      <p
                        style={{
                          fontSize: "20px",
                          margin: "auto",
                          fontWeight: "500",
                          display: "flex",
                        }}
                      >
                        <div>Tema: </div>
                        <div id="current_theme">
                          {localStorage.getItem("font_color_mode") !== null
                            ? localStorage.getItem("font_color_mode") === "dark"
                              ? " dark"
                              : " light"
                            : " auto"}
                        </div>
                      </p>
                    </div>
                    <center>
                      <div
                        onClick={() => {
                          ThemeUtils.reset_theme(components_name_md5)
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === "Space") {
                            ThemeUtils.reset_theme(components_name_md5)
                          }
                        }}
                        role="button"
                        tabIndex="0"
                        style={{
                          fontSize: "12px",
                          width: "fit-content",
                          textAlign: "center",
                          boxSizing: "border-box",
                          border: "1px solid #979797",
                          borderRadius: "11px",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                        }}
                      >
                        Resetta
                      </div>
                    </center>
                  </p>
                </div>
              )}
            </DivFontSize>

            <div
              onClick={() =>
                !showonly_option && toggle_wrapper(components_name_md5)
              }
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === "Space") {
                  !showonly_option && toggle_wrapper(components_name_md5)
                }
              }}
              id={"div_fontsize_wrapper" + components_name_md5}
              role="button"
              aria-label="toggle wrapper"
              tabIndex="0"
              style={{
                width: "10000000px",
                marginLeft: "-5000px",
                marginTop: "-1000px",
                height: "10000px",
                zIndex: "1",
                background: "gray",
                opacity: "0.3",
                display: "none",
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
              }}
            />
          </div>
        )
      )}

export default SharePanel
